/* eslint-disable */

const keys = [
    {
        key: 'appearances',
        label: 'Appearances',
    },
    {
        key: 'market-share',
        label: 'Market Share',
        render: (data, item, totalAppearances, totalScore) =>
            (item.appearances / totalAppearances) * 100,
    },
    {
        key: 'avgPosition',
        label: 'Avg. Ranking',
        icon: 'search',
        yAxisID: 'y2',
    },
    {
        key: 'domainScore',
        label: 'Visibility',
        render: (data, item, totalAppearances, totalScore) => (item.domainScore / totalScore) * 100,
    },
    {
        key: 'uniqueURLs',
        label: 'Daily Unique URLs',
    },
];

export default keys;
